import { ButtonProps } from "./Button";
import {
  buttonWhite,
  buttonOrange,
} from "../../assets/styles/helpers/colors.styles";

export const getButtonStyles = (
  color: ButtonProps["color"],
  variant: ButtonProps["variant"]
) => {
  switch (color) {
    case "primary":
      switch (variant) {
        case "contained":
          return {
            boxShadow: "none",
            backgroundColor: buttonWhite.contained.background,
            color: buttonWhite.contained.font,
            border: "none",
            "&.Mui-disabled": {
              backgroundColor: buttonWhite.contained.backgroundDisabled,
            },
            "&:hover": {
              boxShadow: "none",
              border: "none",
            },
            "&:active": {
              boxShadow: "none",
              backgroundColor: buttonWhite.contained.backgroundActive,
            },
          };
        case "outlined":
          return {
            boxShadow: "none",
            padding: "0.125rem 0.25rem",
            backgroundColor: buttonWhite.outlined.background,
            color: buttonWhite.outlined.font,
            border: `2px solid ${buttonWhite.outlined.border}`,
            "&.Mui-disabled": {
              color: buttonWhite.outlined.fontDisabled,
              border: `2px solid ${buttonWhite.outlined.borderDisabled}`,
            },
            "&:hover": {
              boxShadow: "none",
              border: `2px solid ${buttonWhite.outlined.border}`,
            },
            "&:active": {
              boxShadow: "none",
              backgroundColor: buttonWhite.outlined.backgroundActive,
              border: `2px solid ${buttonWhite.outlined.borderActive}`,
            },
          };
        case "text":
          return {
            boxShadow: "none",
            backgroundColor: buttonWhite.text.background,
            border: "none",
            color: buttonWhite.text.font,
            "&.Mui-disabled": {
              color: buttonWhite.text.fontDisabled,
            },
            "&:hover": {
              boxShadow: "none",
              border: "none",
            },
            "&:active": {
              boxShadow: "none",
              color: buttonWhite.text.fontActive,
            },
          };
      }
      break;
    case "secondary":
      switch (variant) {
        case "contained":
          return {
            boxShadow: "none",
            backgroundColor: buttonOrange.contained.background,
            color: buttonOrange.contained.font,
            border: "none",
            "&:hover": {
              boxShadow: "none",
              border: "none",
            },
            "&:active": {
              boxShadow: "none",
              backgroundColor: buttonOrange.contained.backgroundActive,
            },
            "&.Mui-disabled": {
              backgroundColor: buttonOrange.contained.backgroundDisabled,
            },
          };
        case "outlined":
          return {
            boxShadow: "none",
            padding: "0.125rem 0.25rem",
            backgroundColor: buttonOrange.outlined.background,
            color: buttonOrange.outlined.font,
            border: `2px solid ${buttonOrange.outlined.border}`,
            "&:hover": {
              boxShadow: "none",
              border: `2px solid ${buttonOrange.outlined.border}`,
            },
            "&:active": {
              boxShadow: "none",
              backgroundColor: buttonOrange.outlined.backgroundActive,
              border: `2px solid ${buttonOrange.outlined.borderActive}`,
            },
            "&.Mui-disabled": {
              color: buttonOrange.outlined.fontDisabled,
              border: `2px solid ${buttonOrange.outlined.borderDisabled}`,
            },
          };
        case "text":
          return {
            boxShadow: "none",
            backgroundColor: buttonOrange.text.background,
            border: "none",
            color: buttonOrange.text.font,
            "&:hover": {
              boxShadow: "none",
              border: "none",
            },
            "&:active": {
              boxShadow: "none",
              color: buttonOrange.text.fontActive,
            },
            "&.Mui-disabled": {
              color: buttonOrange.text.fontDisabled,
            },
          };
      }
      break;
    default:
      return {
        boxShadow: "none",
        backgroundColor: buttonWhite.contained.background,
        color: buttonWhite.contained.font,
        border: "none",
        "&.Mui-disabled": {
          backgroundColor: buttonWhite.contained.backgroundDisabled,
        },
        "&:hover": {
          boxShadow: "none",
          backgroundColor: buttonWhite.contained.background,
          border: "none",
        },
        "&:active": {
          boxShadow: "none",
          backgroundColor: buttonWhite.contained.backgroundActive,
        },
      };
  }
};
